import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { Router, ActivatedRoute,NavigationExtras } from '@angular/router';
import { LoaderService } from './../loder_service/loader.service';
declare var $: any;

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss'],
})
export class SplashComponent implements OnInit {

  total_question:any;
  user_exam_id: any;
  subject_name: any;
  exam_duration: any;

  constructor(private navParams: NavParams,public route:ActivatedRoute, public router:Router,public toastService:LoaderService) 
  {
    this.total_question = this.navParams.data.total_question_array;
    this.user_exam_id = this.navParams.data.userexam_id;
    this.subject_name = this.navParams.data.subjectname;
    this.exam_duration = this.navParams.data.exam_duration;
   }

  ngOnInit() {
    $(document).ready(function(){
      $(".down-arrow").click(function(){
        $(".qes-no").toggle(1000);
      });
    });
  }

}
